import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { bindActionCreators } from 'redux';

import { UpdateUser } from '../..';
import { USER_ROLES, USER_STATUSES } from '../../../constants/constants';
import { updateTCRole } from '../../../store/transport_organizations';
import { changeUserStatus } from '../../../store/users';
import { Navigation } from '../../../utils/navigation';
 

const TC_UpdateUser = ({ updateTCRole, changeUserStatus, ...props }) => {
  const navigate = Navigation();
  const { id } = useParams();
  const changeRole = (isAdmin) =>
    updateTCRole({
      userId: id,
      role: isAdmin ? USER_ROLES.TC_ADMIN : USER_ROLES.TC_EMPLOYEE,
      Navigation: navigate,
    });

  const handleConfirmDisableUser = () => changeUserStatus({ id, status: { status: USER_STATUSES.DISABLED },Navigation:navigate});

  return (
    <UpdateUser
      title='User Details'
      headText='Information of the User'
      managedRole='User'
      Navigation ={navigate}
      changeRole={changeRole}
      handleConfirmDisableUser={handleConfirmDisableUser}
      id={id}
      {...props}
    />
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateTCRole,
      changeUserStatus,
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(TC_UpdateUser);
